<template>
	<div id="introduce" v-html="menu.menuText">
		<!-- 项目介绍 -->

		<!-- <h1
			style="margin-top: 23px;margin-bottom: 22px;break-after: avoid;text-align: center;line-height: 70.4px;font-family: 等线;font-size: 29px;text-wrap: wrap">
			<span tyle="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 36px;">
				<strong>“星火计划”项目介绍</strong>
			</span>
		</h1>

		<h3>一、项目发起方介绍</h3>
		<p>中国初级卫生保健基金成立于1996年12月30日，是由中国农工民主党中央委员会主办、中华人民共和国国家卫生健康委员会主管、中华人民共和国民政部登记注册的具有公募资格的4A级基金会。目前，中国初级卫生保健基金会已发展成为一家品牌项目优秀、内部管理规范、规模全国领先、具有较高社会美誉度和业界影响力的公益组织。2022年公益收入与支出均超60亿元人民币，公益规模排名在国内近一万家基金会中居头部。成立27年以来，累计公益规模超过300亿元人民币，为我国初级卫生保健事业的发展做出了突出的贡献。
		</p>
		<h3>二、项目背景介绍</h3>
		<p>中共中央、国务院2016年颁发的《“健康中国2030”规划纲要》提出了“共建共享、全民健康”健康中国建设的战略主题，落实预防为主，推行健康生活方式，减少疾病发生，强化早诊断、早治疗、早康复。国务院正式发布健康中国行动计划，为这一转变描绘了清晰的路线图，其中第一个专项行动就是“健康知识普及行动”。
		</p>
		<p>要实现这一目标，最主要的方式就是开展健康科普，让老百姓愿意看、看得懂、记得住、用得上。针对我国肿瘤诊疗现状和发展趋势，开展新时代健康科普作品征集，汇集卫生健康系统的智慧和力量，集思广益，共同提高，把最优质的健康科普作品奉献给人民群众。
		</p>
		<p>为贯彻落实国家级纲领文件，推动落实健康中国行动癌症防治专项行动，提高全社会癌症防控意识，营造全民防癌抗癌的良好氛围，切实推动广大医务工作者积极投身肿瘤科普作品创作，提升人民群众的健康认知、防治意识。2024年，由中国初级卫生保健基金会指导发起了2024“星火计划”肿瘤科普作品征集项目，项目周期为2024年3月-2025年4月，以科普短视频、科普图文为主要形式，广泛征集优秀科普作品，助力中国医疗健康建设。
		</p>
		<p>秉持共同的健康理念，助力推进“健康中国2030”早日实现，诚邀各医药相关企事业单位共同参与。</p>
		<h3>三、项目目标</h3>
		<p>通过项目开展，征集10000份肿瘤科普作品，选出200份优秀科普作品，通过作品表彰及创作支持，鼓励更多临床医务工作者关注肿瘤科普，加入肿瘤科普，为肿瘤科普事业贡献新的力量。</p>
		<p>通过肿瘤科普知识的传递，提高大众对肿瘤预防、治疗、康复等内容规范化管理的重要性的认识；帮助大众更好地了解医学知识，确保科普内容的准确性和权威性，为读者提供可靠的信息，避免误导和误解。</p> -->
	</div>
</template>

<script>
	import {
		ProjectPage // 优秀稿件
	} from '@/request/api';
	export default {
		name: 'introduce',
		data() {
			return {
				menu: '',
				status: ''
			}
		},
		created() {
			this.status = this.$route.query.status;
		},
		mounted() {
			this.getProjectPage();
		},
		updated() {
			this.status = this.$route.query.status;
		},
		methods: {
			getProjectPage() {
				ProjectPage().then(res => {
					if (res.code == 200) {
						let resData = res.data.menus;
						this.menu = resData.find(item => item.status == this.status)
						this.$forceUpdate();
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	#introduce {
		* {
			text-align: justify;
		}

		h1 {
			font-size: 30px;
			text-align: center;
			font-weight: bold;
		}

		h3 {
			font-weight: bold;
			margin-bottom: 20px;
			font-size: 18px;
		}

		p {
			font-size: 16px;
			margin-bottom: 10px;
			line-height: 2;
		}
	}
</style>